import { render, staticRenderFns } from "./SizeManager.vue?vue&type=template&id=32abf5b0&"
import script from "./SizeManager.vue?vue&type=script&lang=js&"
export * from "./SizeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports